/**
* @Author: zachalam
* @Date:   2017-01-18T15:30:32-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-05T17:03:20-07:00
*/



import React, { Component } from 'react';
import SubNav from '../../blocks/SubNav';

import GeneralSettings from './GeneralSettings';
import Privacy from './Privacy';
import Notifications from './Notifications';
import Panel from '../../common/Panel';
import Container from '../../blocks/Container';
import { dimensions, spacing, borders } from '../../../style';
import { css, StyleSheet } from 'aphrodite/no-important';

const style = StyleSheet.create({
  nav: {
    [dimensions.SCREEN_MIN_SM]: {
      flexBasis: '220px',
      flexGrow: '0',
      flexShrink: '0',
      borderRight: borders.DEFAULT
    }
  },

  main: {
    [dimensions.SCREEN_MIN_SM]: {
      display: 'flex',
      flexDirection: 'row',
    }
  },

  content: {
    ...spacing.MARGIN_BOTTOM_LG,

    [dimensions.SCREEN_MIN_SM]: {
      flexGrow: '1',
      maxWidth: '450px',
      ...spacing.PADDING_H_MD
    }
  }
});

class Settings extends Component {

  constructor(props) {
    super(props);
    this.renderSection = this.renderSection.bind(this);
  }

  renderSection(page) {
    switch(page) {
      case 'privacy':
        return <Privacy updateAccountSetting={this.props.updateAccountSetting}
          settings={this.props.settings} blocked={this.props.blocked} />;
      case 'notifications':
        return <Notifications updateAccountSetting={this.props.updateAccountSetting}
          settings={this.props.settings} />;
      default:
        return <GeneralSettings
          subscription={this.props.subscription}
          confirmCancel={this.props.confirmCancel}
          errors={this.props.errors}
          updatePasswordForm={this.props.updatePasswordForm}
          updateEmailForm={this.props.updateEmailForm}
          settings={this.props.settings}
          isFemale={this.props.isFemale} />;
    }
  }


  render() {
    let page = this.props.route.page;
    //console.log(page);
    return (
      <Container screenTop fullWidth>
        <Panel padding='none'>
          <div className={css(style.main)}>
            <nav className={css(style.nav)}>
              <SubNav vertical
                pages={['Settings','Privacy','Notifications']}
                urls={['/settings', '/settings/privacy', '/settings/notifications']} />
              </nav>

              <div className={css(style.content)}>
                {this.renderSection(page)}
              </div>
          </div>
        </Panel>
      </Container>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/Settings.jsx